import { useMediaQuery } from 'react-responsive';

const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xlg: 1280,
};

export const useSmMediaQuery = () =>
  useMediaQuery({ minWidth: breakpoints.sm });

export const useMdMediaQuery = () =>
  useMediaQuery({ minWidth: breakpoints.md });

export const useLgMediaQuery = () =>
  useMediaQuery({ minWidth: breakpoints.lg });

export const useXLgMediaQuery = () =>
  useMediaQuery({ minWidth: breakpoints.xlg });
